// No need to import React with modern JSX transform
interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

export function Logo({ className = '', width = 28, height = 28, color = 'white' }: LogoProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 512 512" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Home calculator logo"
    >
      {/* House outline */}
      <path 
        d="M256,112L112,256v160h288V256L256,112z M224,416v-96h64v96H224z" 
        fill="none" 
        stroke={color} 
        strokeWidth="32" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Full logo with gradient background (useful for favicon or app icon)
export function FullLogo({ className = '', width = 28, height = 28 }: LogoProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 512 512" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Home calculator logo with background"
    >
      {/* Gradient background */}
      <defs>
        <linearGradient id="headerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#194775"/>
          <stop offset="100%" stopColor="#2D6E92"/>
        </linearGradient>
      </defs>
      
      {/* Square with gradient */}
      <rect width="512" height="512" fill="url(#headerGradient)" rx="64" ry="64"/>
      
      {/* House outline */}
      <path 
        d="M256,112L112,256v160h288V256L256,112z M224,416v-96h64v96H224z" 
        fill="none" 
        stroke="white" 
        strokeWidth="32" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Simple house icon without the door (alternative version)
export function SimpleHouse({ className = '', width = 28, height = 28, color = 'white' }: LogoProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 512 512" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Simple house icon"
    >
      <path 
        d="M256,112L112,256v160h288V256L256,112z" 
        fill="none" 
        stroke={color} 
        strokeWidth="32" 
        strokeLinejoin="round"
      />
    </svg>
  );
}